import React, { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import useAPIQuery from '../api/useAPIQuery';

interface IsStaffCheckerProps {
  redirectTo?: string;
}

const IsStaffChecker: React.FC<IsStaffCheckerProps> = ({ children, redirectTo }) => {
  const user = useAPIQuery('/users/me/');

  if (user.data?.is_staff) {
    return children ? (children as ReactElement) : <Outlet />;
  }

  if (user.isSuccess && redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return null;
};

export default IsStaffChecker;
